import React, { useId } from 'react';
import { useDebounceEffect } from 'ahooks';
import { loadScript } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';

interface IProps {
    children: JSX.Element;
    extra_properties: { [key: string]: string }; // 运营提供
    success_message?: string;
    successCallback?: () => void;
    errorCallback?: () => void;
}
const Klaviyo = ({ children, extra_properties, success_message, successCallback, errorCallback }: IProps) => {
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    const formIdRaw = `${useId()}`;
    const formId = formIdRaw?.replace(/:/g, '').concat('-id');

    useDebounceEffect(() => {
        /**
         * @document https://developers.klaviyo.com/en/docs/track-klaviyo-form-activity-using-javascript
         * @helpCenter https://help.klaviyo.com/hc/en-us/categories/360000190711-Signup-Forms
         */

        let errObserver: any = null;
        // loadScript('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=W9vZP6')
        loadScript('//www.klaviyo.com/media/js/public/klaviyo_subscribe.js').then(() => {
            const win = window as any;
            const KlaviyoSubscribe = win.KlaviyoSubscribe;
            KlaviyoSubscribe.attachToForms(`#${formId}`, {
                hide_form_on_success: false,
                success_message: success_message || t('common.email_validation_success'),
                extra_properties: extra_properties,
                success: (form: any) => {
                    successCallback && successCallback();
                    setTimeout(() => {
                        // 成功一定时间后关闭成功消息提示
                        // const error_wrap = document.querySelector(`#${formId} .klaviyo_messages .error_message`) as any;
                        // if (error_wrap) {
                        //     error_wrap.innerText = '';
                        //     error_wrap.style.display = 'none';
                        // }
                        const error_wrap = document.querySelectorAll('.klaviyo_messages .success_message') as any;
                        error_wrap &&
                            error_wrap.forEach((item: any) => {
                                item.innerText = '';
                                item.style.display = 'none';
                            });
                    }, 200000);
                },
            });

            const errObCallback = function (mutationsList: any) {
                const target = mutationsList[0]?.target;
                if (target.innerText === 'Invalid email address') {
                    target.innerText = t('common.email_validation_error');
                }
                if (target.innerHTML === 'Invalid email address') {
                    target.innerHTML = t('common.email_validation_error');
                }
                if (target.style.display !== 'none' && mutationsList[0]?.type === 'attributes') {
                    errorCallback && errorCallback();
                }
            };
            errObserver = new MutationObserver(errObCallback);

            errObserver.observe(document.querySelector(`#${formId} .klaviyo_messages .error_message`), {
                attributes: true,
                attributeFilter: ['style'],
                childList: true,
            });
        });
        return () => {
            errObserver?.disconnect();
        };
    }, []);
    return <>{React.cloneElement(children, { id: formId })}</>;
};
export default Klaviyo;
